/**
 * Type for a linear direction.
 */
export enum Direction {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left'
}

/**
 * Interface for extending with a single 'direction' property.
 */
export interface DirectionProp {
  /**
   * The {@link Direction}.
   */
  direction?: Direction;
}
